import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import isSubscribedTo from '@/utils/subscriptionsHelper';
import { datasetSubscriptions } from '@/notifications/subscribers/constants';
import { states } from '@/constants/lifecycle';

const useDatasetSubscribeAction = ({ category, code }) => useSelector(({
  datasets: { datasets },
  themes: { theme },
}) => {
  const item = findResult(datasets, category, code);
  const subscribed = item ? isSubscribedTo(item, datasetSubscriptions.DATASET_UPDATE) : null;

  return {
    disabled: !item || item.subscriptionsStatus === states.PENDING,
    subscribed,
    theme,
  };
});

export default {
  useDatasetSubscribeAction,
};
